import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import { seuilsInitialState, SeuilsStateProps, seuilsStateStore } from './seuils-state.store';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SettingsSeuilsRepository extends BaseStoreRepository<SeuilsStateProps> {
  constructor() {
    super(seuilsStateStore.pipe(select(state => state)), seuilsStateStore, seuilsInitialState);
  }
}
